// extracted by mini-css-extract-plugin
export var messageSideLeft = "_lo-1";
export var messageSideRight = "_lo-2";
export var orderLookupBubbleContainer = "_lo-0";
export var submitButton = "_lo-3";